// This file include all user-authentication related the keys of
// action to perform calls to the reducer or sagas.

// This object define all the user-authentication action keys.
const userAuthenticationActions = Object.freeze({
    USER_AUTHENTICATION_RESET_STATE_SUCCESS: 'USER_AUTHENTICATION_RESET_STATE_SUCCESS',
    USER_AUTHENTICATION_INPUT_CHANGE_START: 'USER_AUTHENTICATION_INPUT_CHANGE_START',
    USER_AUTHENTICATION_INPUT_CHANGE_SUCCESS: 'USER_AUTHENTICATION_INPUT_CHANGE_SUCCESS',
    USER_AUTHENTICATION_MODE_CHANGE_START: 'USER_AUTHENTICATION_MODE_CHANGE_START',
    USER_AUTHENTICATION_MODE_CHANGE_SUCCESS: 'USER_AUTHENTICATION_MODE_CHANGE_SUCCESS',
    USER_AUTHENTICATION_PROCESS_START: 'USER_AUTHENTICATION_PROCESS_START',
    USER_AUTHENTICATION_PROCESS_PREPARATION: 'USER_AUTHENTICATION_PROCESS_PREPARATION',
    USER_AUTHENTICATION_PROCESS_VALIDATION_ERROR: 'USER_AUTHENTICATION_PROCESS_VALIDATION_ERROR',
    USER_AUTHENTICATION_PROCESS_SUCCESS: 'USER_AUTHENTICATION_PROCESS_SUCCESS',
    USER_AUTHENTICATION_PROCESS_FAIL: 'USER_AUTHENTICATION_PROCESS_FAIL',
    USER_AUTHENTICATION_CHECK_STATE_START: 'USER_AUTHENTICATION_CHECK_STATE_START',
    USER_AUTHENTICATION_CHECK_TIMEOUT_START: 'USER_AUTHENTICATION_CHECK_TIMEOUT_START',
    USER_AUTHENTICATION_LOGOUT_START: 'USER_AUTHENTICATION_LOGOUT_START',
    USER_AUTHENTICATION_LOGOUT_SUCCESS: 'USER_AUTHENTICATION_LOGOUT_SUCCESS'
});

export default userAuthenticationActions;